"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportBusinessBodyToJSON = exports.ImportBusinessBodyFromJSONTyped = exports.ImportBusinessBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ImportBusinessBodyFromJSON(json) {
    return ImportBusinessBodyFromJSONTyped(json, false);
}
exports.ImportBusinessBodyFromJSON = ImportBusinessBodyFromJSON;
function ImportBusinessBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(_1.ImportBusinessBodyItemFromJSON)),
    };
}
exports.ImportBusinessBodyFromJSONTyped = ImportBusinessBodyFromJSONTyped;
function ImportBusinessBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(_1.ImportBusinessBodyItemToJSON)),
    };
}
exports.ImportBusinessBodyToJSON = ImportBusinessBodyToJSON;
